import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EventGraphQL from '@graphql/event.queries';
import { Event } from '@models/event.model';

interface UseEventsReturn {
  events: Event[];
  loading: boolean;
  error: string | null;
  fetchEvents: (projectId: string) => Promise<void>;
}

export const useEvents = (): UseEventsReturn => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEvents = useCallback(async (projectId: string) => {
    if (!projectId) return;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        EventGraphQL.queries.getEvents,
        { projectId },
      );

      const fetchedEvents = data?.getEvents || [];
      setEvents(fetchedEvents);
    } catch (err: any) {
      setError(err?.response?.errors?.[0]?.message || 'Failed to fetch events');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    events,
    loading,
    error,
    fetchEvents,
  };
};
